import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  private emailSubject = new BehaviorSubject<string | null>(sessionStorage.getItem('user_email'));



  /**
   * @description Gets the email from the session storage and updates the email subject.
   * @returns {Observable<string | null>} Observable of the email.
   */
  getEmail(): Observable<string | null> {
    return this.emailSubject.asObservable();
  }

  /**
   * @description Gets the current email value synchronously without subscribing.
   * @returns {string | null} Current email value.
   */
  getCurrentEmail(): string | null {
    return this.emailSubject.getValue();
  }

  /**
   * @description Sets the email in the session storage and updates the email subject.
   * @param {string} email - The email to set.
   * @returns {void} void
   */
  setEmail(email: string) {
    sessionStorage.setItem('user_email', email);
    this.emailSubject.next(email);
  }

  /**
   * @description Clears the email from the session storage and updates the email subject.
   * @returns {void} void
   */
  clearEmail(): void {
    sessionStorage.removeItem('user_email');
    this.emailSubject.next(null);
  }

  /**
   * In-memory draft password captured on the onboarding wrapper and consumed by
   * the final POST /users/create call. Intentionally NOT persisted to
   * sessionStorage — clears on page refresh so the user re-enters it.
   */
  private passwordDraft: string | null = null;

  /**
   * @description Caches the password draft during the onboarding stepper.
   * @param {string} password - Plaintext password captured on the wrapper form.
   */
  setPassword(password: string): void {
    this.passwordDraft = password;
  }

  /**
   * @description Returns the cached password draft (or null if none).
   * @returns {string | null}
   */
  getCurrentPassword(): string | null {
    return this.passwordDraft;
  }

  /**
   * @description Clears the cached password draft. Called after POST /users/create
   * succeeds or when the user leaves the onboarding flow.
   */
  clearPassword(): void {
    this.passwordDraft = null;
  }
}
